import { GetterTree } from 'vuex';
import { IRootState } from '@/store/types';
import { IState } from './types';
import actions from './actions';
import mutations from './mutations';
import { Type } from '@/sandbox';

/**
 * store state仅适用以下情况
 * 目前当前页面只有一个normal/jupyter沙盒
 */

const DEFAULT_SANDBOX = {
  token: '',
  rootPath: '',
  compress: null,
  tree: null,
  files: [],
  resetPath: '',
  sandboxConfig: null,
  limitState: null,
  loading: false,
  isRecycled: false
};

const state: IState = {
  type: Type.jupyter,
  ...DEFAULT_SANDBOX
};

const getters: GetterTree<IState, IRootState> = {
  file(state) {
    return state.files.filter((item) => item.isSelected)[0] || {};
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
